// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__1sVUd","info":"PatientInfo_info__16uqy"};